import type { NotificationDetail } from '@jemmi/schemas';

import { apiRequest } from '@/lib/apiClient';

export async function fetchNotifications(): Promise<NotificationDetail[]> {
  const data = await apiRequest<{ items: NotificationDetail[] }>('/notifications');
  return data.items;
}

export async function markNotificationRead(notificationId: string): Promise<NotificationDetail> {
  const data = await apiRequest<{ notification: NotificationDetail }>(
    `/notifications/${notificationId}/mark-read`,
    { method: 'POST' },
  );
  return data.notification;
}

export async function takeNotificationAction(
  notificationId: string,
  action: 'approve' | 'remove',
): Promise<NotificationDetail> {
  const data = await apiRequest<{ notification: NotificationDetail }>(
    `/notifications/${notificationId}/action`,
    {
      method: 'POST',
      body: JSON.stringify({ action }),
    },
  );
  return data.notification;
}
